import { jwtDecode } from "jwt-decode";

export const BEARER_TOKEN_KEY = "BearerToken";
export const RPC_TOKEN_KEY = "Token";
export const LEGACY_TOKEN_KEY = "token";

export const isTokenExpired = (token, { expireOnError = false } = {}) => {
    if (!token) return true;

    try {
        const { exp } = jwtDecode(token);
        if (!exp) return false;
        return Date.now() >= exp * 1000;
    } catch {
        return expireOnError;
    }
};
